import React from "react";

import { completMonth } from "@/utils/dateFormater";
import { getYearOptions } from "@/utils/getYearOptions";

export interface ReferenceMonthPickerProps {
  /** Mês de referência no formato "YYYY-MM" */
  value: string;
  onChange: (value: string) => void;
  /** Limita a seleção até esse mês ("YYYY-MM"), inclusive — ex.: bloquear futuro */
  max?: string;
}

const selectClass =
  "h-10 w-full cursor-pointer appearance-none rounded-lg border border-grey100 bg-white px-3 text-sm font-medium text-black focus:outline-none";

/**
 * Seletor de mês de referência: um dropdown de mês (pt-BR) + um de ano.
 * Valor controlado no formato "YYYY-MM" (mesmo formato do input type="month").
 */
const ReferenceMonthPicker = ({ value, onChange, max }: ReferenceMonthPickerProps) => {
  const [year, month] = value.split("-");
  const maxYear = max?.split("-")[0];
  const maxMonthNumber = max && year === maxYear ? Number(max.split("-")[1]) : 12;

  const years = getYearOptions().filter((y) => !maxYear || Number(y) <= Number(maxYear));
  const months = completMonth.slice(0, maxMonthNumber);

  const change = (nextYear: string, nextMonthNumber: number) => {
    onChange(`${nextYear}-${String(nextMonthNumber).padStart(2, "0")}`);
  };

  return (
    <div className="grid grid-cols-[1fr_auto] gap-3">
      <label className="block">
        <span className="mb-1 block text-xs font-bold uppercase text-grey500">Mês</span>
        <select
          className={selectClass}
          value={month}
          onChange={(event) => change(year, Number(event.target.value))}
        >
          {months.map((monthName, index) => (
            <option key={monthName} value={String(index + 1).padStart(2, "0")}>
              {monthName}
            </option>
          ))}
        </select>
      </label>

      <label className="block">
        <span className="mb-1 block text-xs font-bold uppercase text-grey500">Ano</span>
        <select
          className={selectClass}
          value={year}
          onChange={(event) => {
            const nextYear = event.target.value;
            // se voltar para o ano máximo, trava o mês no limite (ex.: max 2026-09)
            const clampedMonth =
              max && nextYear === maxYear
                ? Math.min(Number(month), Number(max.split("-")[1]))
                : Number(month);
            change(nextYear, clampedMonth);
          }}
        >
          {years.map((yearOption) => (
            <option key={yearOption} value={yearOption}>
              {yearOption}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
};

export default ReferenceMonthPicker;
